<template>
  <div>
    <transition name="fade">
      <div class="preloader" v-show="!pageLoaded">
        <div class="loader">
          <div class="loader__figure">

          </div>
          <p class="loader__label"><img src="../assets/achiev-logo.svg" alt="homepage" class="dark-logo" /></p>
        </div>
      </div>
    </transition>
    <!-- ============================================================== -->
    <!-- Main wrapper - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <div id="main-wrapper">
      <!-- ============================================================== -->
      <!-- Topbar header - style you can find in pages.scss -->
      <!-- ============================================================== -->
      <header ref="topbar" class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
          <!-- ============================================================== -->
          <!-- Logo -->
          <!-- ============================================================== -->
          <div class="navbar-header">
            <router-link class="navbar-brand" to="/dashboard" v-show="!showIcon">
              <!--End Logo icon -->
              <!-- Logo text -->
              <span v-show="showNavbar" class="achiev-logo">
                         <!-- dark Logo text -->
                         <img src="../assets/achiev-logo.svg" alt="homepage" class="dark-logo" />
                <!-- Light Logo text -->
                         <img src="../assets/achiev-logo.svg" class="light-logo" alt="homepage" />
              </span>
            </router-link>
            <router-link class="navbar-brand" to="/dashboard" v-show="showIcon">
              <!-- Logo icon -->
              <img src="../assets/achiev-ico.png" alt="homepage" class="light-logo" style="display: inline;" />
            </router-link>
          </div>
          <!-- ============================================================== -->
          <!-- End Logo -->
          <!-- ============================================================== -->
          <div class="navbar-collapse">
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <ul class="navbar-nav mr-auto" v-on:click="toggleSidebar">
              <!-- This is the menu icon-->
              <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
              <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
            </ul>
            <!-- ============================================================== -->
            <!-- User profile and search -->
            <!-- ============================================================== -->
            <ul class="navbar-nav my-lg-0">
              <!-- ============================================================== -->
              <!-- Search -->
              <!-- ============================================================== -->

              <!-- ============================================================== -->
              <!-- Comment -->
              <!-- ============================================================== -->
              <li class="nav-item dropdown">
                <span class="nav-link">
                  <small class="text-danger" v-if="!connectionStatus.value">{{ $t("No connection") }}</small>
                  <i class="fas fa-rss p-l-10 wifi-icon" v-bind:class="{'text-danger' : !connectionStatus.value}" data-fa-transform="rotate-45"></i>
                </span>

                <!--
                <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="readNotifications">
                  <i class="ti-comment"></i>
                  <div class="notify" v-show="!notificationsRead">
                    <span class="heartbit"></span>
                    <span class="point"></span>
                  </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown" >
                  <ul>
                    <li>
                      <div class="drop-title">{{ $t("Notifications") }}</div>
                    </li>
                    <li>
                      <div class="message-center" v-for="note in user.Notes.data">
                        <a>
                          <div class="btn btn-danger btn-circle"><i class="fa fa-link"></i></div>
                          <div class="mail-contnet">
                            <h5>{{ note.title }}</h5>
                            <span class="mail-desc">{{ note.note }}</span>
                            <span class="time">{{ note.timestamp | formatDate }}</span>
                          </div>
                        </a>
                      </div>
                    </li>
                    <li>
                      <a class="nav-link text-center"> <strong>{{ $t("Check all notifications") }}</strong> <i class="fa fa-angle-right"></i> </a>
                    </li>

                  </ul>
                </div>
                                    -->
              </li>
              <!-- ============================================================== -->
              <!-- End Comment -->
              <!-- ============================================================== -->
              <!-- ============================================================== -->

              <!-- Profile -->
              <!-- ============================================================== -->
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <small class="onmobile-hide">{{ user.firstname }} {{ user.lastname }}</small>
                  <!-- TODO: Replace test.achiev.eu-->
                  <img :src="user.photo" alt="user" class="font-rem user-avatar"/>
                </a>
                <div class="dropdown-menu dropdown-menu-right animated flipInY">
                  <ul class="dropdown-user">
                    <li>
                      <div class="dw-user-box">

                        <div class="u-img">
                          <!-- TODO: remove test.achiev.eu -->
                          <img class="circle-image" :src="user.photo" alt="user" width="70" height="70">
                        </div>
                        <div class="u-text">
                          <h4>{{ user.firstname }} {{ user.lastname }}</h4>
                          <p class="text-muted">{{ user.email }}</p>
                          <router-link to="/profile" class="btn btn-rounded btn-info btn-sm">{{ $t("View Profile") }}</router-link></div>
                      </div>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li>
                      <router-link to="/profile"><i class="ti-user"></i> {{ $t("My Profile") }}</router-link>
                    </li>
                    <li>
                      <div v-on:click="logUserOut"><a>
                        <i class="fa fa-power-off"></i>
                        {{ $t("Logout") }}
                      </a></div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <!-- ============================================================== -->
      <!-- End Topbar header -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Left Sidebar - style you can find in sidebar.scss  -->
      <!-- ============================================================== -->
      <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
          <!-- Sidebar navigation-->
          <nav class="sidebar-nav">
            <ul id="sidebarnav">
              <li @click="clickLink">
                <router-link to="/dashboard" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="ti-view-grid"></i><span class="hide-menu">{{ $t("Dashboard") }}</span>
                </router-link>
              </li>
              <li @click="clickLink">
                <router-link to="/actions" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="ti-check-box"></i><span class="hide-menu">{{ $t("My Actions") }}</span>
                </router-link>
              </li>
              <li @click="clickLink">
                <router-link to="/meetings" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="ti-calendar"></i><span class="hide-menu">{{ $t("My Meetings") }}</span>
                </router-link>
              </li>
              <li @click="clickLink">
                <router-link to="/reports" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="ti-bar-chart"></i><span class="hide-menu">{{ $t("Reports") }}</span>
                </router-link>
              </li>
              <li @click="clickLink">
                <router-link to="/profile" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="ti-user"></i><span class="hide-menu">{{ $t("Profile") }}</span>
                </router-link>
              </li>

            </ul>
          </nav>
          <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
      </aside>
      <!-- ============================================================== -->
      <!-- End Left Sidebar - style you can find in sidebar.scss  -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Page wrapper  -->
      <!-- ============================================================== -->
      <div :class="{'wrapper' : inMeeting}" class="page-wrapper">

        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div :class="{'container-base' : inMeeting}" class="container-fluid">
          <!-- ============================================================== -->
          <!-- Bread crumb and right sidebar toggle -->
          <!-- ============================================================== -->
          <div ref="pagetitles" :class="{'row-align': inMeeting}" class="row page-titles">
            <div class="col-md-8 align-self-center" :class="{'see-through-title' : inMeeting}">
              <router-link style="margin-bottom: 2rem" v-if="inMeeting" to="/meetings/"><i class="ti-arrow-left"></i> Back to meeting overview</router-link>

              <h2 v-if="$route.name === 'Dashboard'">{{ $t("My Dashboard") }} <span v-if="title.length > 0">- {{ title }}</span></h2>
              <h2 v-else-if="$route.name === 'Actions'">{{ $t("My Actions") }} <span v-if="title.length > 0">- {{ title }}</span></h2>
              <h2 v-else-if="$route.name === 'My Meetings'">{{ $t("My Meetings") }} <span v-if="title.length > 0">- {{ title }}</span></h2>
              <h2 v-else-if="$route.name === 'Reports'">{{ $t("Reports") }} <span v-if="title.length > 0">- {{ title }}</span></h2>
              <h2 v-else-if="$route.name === 'My Profile'">{{ $t("My Profile") }} <span v-if="title.length > 0">- {{ title }}</span></h2>

              <h2 v-else :class="{'text-muted': inMeeting}">{{ title }}</h2>
              <router-link v-if="typeof $route.meta.parentRoute !== 'undefined' && $route.meta.parentRoute !== null && $route.name !=='Meeting' && $route.name !== 'Edit action'"
                           :to="$route.meta.parentRoute.join('')">
                &larr; {{ $t("Go back to ")}} {{ $route.meta.parentRouteName.join().toLowerCase() }}

              </router-link>
              <router-link v-if="$route.name ==='Edit action'" :to="'/action/' + $route.params.id">
                &larr; {{ $t("Go back to ")}} action
              </router-link>
              </div>
            <div :class="{'breadcrumbs': inMeeting}" class="col-md-4 align-self-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/dashboard">{{ $t("Home") }}</router-link></li>
                <template v-if="$route.meta.parentRoute !== null">
                  <li class="breadcrumb-item" v-for="(titleItem, $index) in $route.meta.parentRouteName">
                    <router-link  :to="$route.meta.parentRoute[$index]">{{ titleItem }}</router-link>
                  </li>

                  <li class="breadcrumb-item" v-if="$route.meta.displayName">
                    {{ pageTitle }}
                  </li>
                </template>
                <li class="breadcrumb-item" v-if="$route.meta.parentRoute === null">
                  {{ $route.name }}
                </li>
              </ol>
            </div>
            <!--                 <div class="">
                                <button class="right-side-toggle waves-effect waves-light btn-inverse btn btn-circle btn-sm pull-right m-l-10"><i class="ti-settings text-white"></i></button>
                            </div> -->
          </div>
          <!-- ============================================================== -->
          <!-- End Bread crumb and right sidebar toggle -->
          <!-- ============================================================== -->
          <router-view></router-view>
        </div>

        <!-- ============================================================== -->
        <!-- End Right panel -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- End Page Content -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Right sidebar -->
        <!-- ============================================================== -->
        <!-- .right-sidebar -->
        <div class="right-sidebar">

        </div>
        <!-- ============================================================== -->
        <!-- End Right sidebar -->
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- footer -->
      <!-- ============================================================== -->
      <footer ref="footer" v-if="meetingID === null || total_max_time === null" class="footer text-right"> © {{new Date().getFullYear()}} AchieV | <a style="color: #1bb5eb" href="">{{ $t("Support") }}</a> </footer>

      <footer ref="footer" v-else class="footer" style="position: fixed; z-index: 50; background-color: #1bb5eb;">
        <div class="footer-content">
          <div class="left-side">
          <div class="footer-icon">
            <i class="ti-settings"></i>
          </div>
          <div class="meeting-title">
            <h2>{{ meeting_name }}</h2>
            <p>{{ $t("Running in the background...") }}</p>
          </div>
          <div class="back-button">
            <router-link :to="'/havemeeting/' + meetingID" class="btn-xl btn-rounded btn-light return-meeting-button">
              <span class="text-info"><i class="ti-back-left"></i> {{ $t("Return to meeting") }}</span>
            </router-link>
          </div>
          </div>
          <div class="elapsed-time">
            <span><i class="ti-time"></i></span>
            <span v-bind:class="{'text-danger': total_time > total_max_time }"> {{ formatTime(total_time) }}
              <span class="text-white"> / {{ formatTime(total_max_time) }} </span>
            </span>
          </div>
        </div>
      </footer>
      <!-- ============================================================== -->
      <!-- End footer -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  import router from '../router'

  export default {
    name: 'Frame',
    mounted() {
      // When the component is registered, add the click listeners for network changes
      let vm = this;
      window.addEventListener("online", this.networkChange);
      window.addEventListener("offline", this.networkChange);
      window.addEventListener("resize", this.onResize);
      this.$translate.setLang(this.lang);

      this.$on('userUpdate', function (data) {
        this.user = data;
      });

      this.$on("addTitleBreadcrumb", function (data) {
        this.pageTitle = data;
      });
      this.$on("removeTitleBreadcrumb", function (data) {
        this.pageTitle = "";
      });

      let settings = this.user.Settings.data;

      for(let setting in settings){
        if(settings[setting].setting === "language"){
          this.$root.$i18n.locale = settings[setting].value;
        }
      }

        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth();
        this.getWindowHeight();

        if ((document.body.classList).contains('mini-sidebar') && this.windowWidth > 1160) {
          vm.toggleSidebar();
        }

      if (vm.total_time !== null && vm.interval === null) {
        vm.interval = setInterval(() => vm.itemTimer(), 1000);
      } else if (vm.total_max_time === null && vm.interval !== null) {
        clearInterval(this.interval);
        localStorage.removeItem('total_time');
        localStorage.removeItem('total_max_time');
        localStorage.removeItem('meeting_name');
        localStorage.removeItem('meeting_id');
      }

      this.pageLoaded = true;

    },
    created(){
      let vm = this;
      if (localStorage.getItem('expires') < Math.floor(+ new Date() / 1000)) {
        console.log("Logging out because token is expired");
        vm.logUserOut();
      }


      if (this.$route.fullPath === "/") {
        this.$router.push('/dashboard');
      }

      // if (vm.user["Notes"]["data"].length > 0) {
      //   vm.notationsRead = false;
      // } else {
      //   vm.notificationsRead = true;
      // }

      if ((document.body.classList).contains('mini sidebar') && this.windowWidth > 1170) {
        vm.toggleSidebar();
      }
    },
    beforeDestroy() {
      clearInterval(this.interval);
      window.removeEventListener('resize', this.getWindowWidth);
      window.removeEventListener('resize', this.getWindowHeight);
    },
    locales: {
      en_en: require('../assets/translations/en-en'),
      nl_nl: require('../assets/translations/nl-nl'),
      iw_iw: require('../assets/translations/iw-iw'),
      de_de: require('../assets/translations/de-de')
    },
    methods: {
      toggleSidebar(){
        let vm = this;
        const body = document.body;
        if((body.classList).contains("mini-sidebar")) {
          body.classList.remove("mini-sidebar");
          vm.showNavbar = true;
        } else {
          body.classList.add("mini-sidebar");
          vm.showNavbar = false;
        }
      },
      clickLink(){
        if(window.innerWidth < 768){
          document.body.querySelector(".nav-toggler i").click();
        }
      },
      networkChange (args) {
        // Change the connectionstatus according to the current connection
        if (args.type === "offline") {
          this.connectionStatus.value = false;
          this.connectionStatus.text = "Disconnected";
        } else {
          this.connectionStatus.value = true;
          this.connectionStatus.text = "Connected";
        }
      },

      logUserOut: function () {
        localStorage.clear();
        this.$router.push("/login");
      },

      // readNotifications(){
      //   this.notificationsRead = true;
      //   for(let i = 0; i < this.user.Notes.data.length; i++){
      //     let note = this.user.Notes.data[i];
      //     if(note.read !== true){
      //       APIHelper.patchResource("/api/user/{uid}/note/" + note.uid, {}).then(function (data) {
      //       });
      //     }
      //   }
      // },

      // nicely formats an amount of seconds to a nice timestring
      formatTime(time) {
        let vm = this;

        let s = time % 60;
        let m = ((time - s) / 60) % 60;

        let h = (time - ((m * 60) + s)) / 3600;
        let final = '';

        s = vm.padTime(s);
        m = (h > 0 ? vm.padTime(m) : m);
        if (h !== 0) {
          final = h + ':';
        }

        final += m + ':' + s;

        return final;
      },

      getTopbar: function() {
        return this.$refs['topbar'].clientHeight;
      },

      getPageTitles: function() {
        return this.$refs['pagetitles'].clientHeight;
      },

      getFooter: function() {
        return this.$refs['footer'].clientHeight;
      },

      // "pad" the tame with leading zero's
      padTime(time) {
        return (time < 10 ? '0' : '') + time;
      },

      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
      },

      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
      },

      totalTime() {
        let vm = this;
        if (vm.total_time !== null && vm.meetingID !== null && vm.total_max_time !== null) {
          APIHelper.getResource("/api/meeting/" + vm.meetingID + "/time-elapsed").then((data) => {
            vm.total_time = data.meeting;
            localStorage.setItem('total_time', data.meeting);
          })
        }
      },

      // The timer that keeps counting
      itemTimer() {
        let vm = this;
          if ((typeof Number(vm.total_max_time) !== "number") || (typeof Number(vm.total_time) !== "number")) {
          clearInterval(vm.interval);
          vm.total_time = null;
          localStorage.removeItem('total_time');
          localStorage.removeItem('meeting_name');
          localStorage.removeItem('meeting_id');
          localStorage.removeItem('meeting_state');
          localStorage.removeItem('total_max_time');
          return;
        }

        if (vm.meetingsync % 60 === 0 && vm.total_max_time !== null) {
          vm.totalTime();
          vm.meetingsync = 0;
        }

        vm.meetingsync = Number(vm.meetingsync) + 1;
        vm.total_time = Number(vm.total_time) + 1;
        localStorage.setItem("total_time", vm.total_time);
      },

      onResize($evt){
        this.showIcon = $evt.target.innerWidth < 1170;
      }

    },
    data: function () {
      return {
        pageLoaded: false,
        lang: "nl_nl",
        user: APIHelper.getUserData(),
        notificationsRead: false,
        connectionStatus: {
          text: "Connected",
          value: true
        },
        title: "",
        total_time: (localStorage.getItem("total_time") === "null" ? null : localStorage.getItem("total_time")),
        total_max_time: (localStorage.getItem("total_max_time") === "null" ? null : localStorage.getItem("total_max_time")),
        meetingID: (localStorage.getItem("meeting_id") === "null" ? null : localStorage.getItem("meeting_id")),
        meeting_name: (localStorage.getItem("meeting_name") === "null" ? null : localStorage.getItem("meeting_name")),
        pageTitle: "",
        inMeeting: false,
        interval: null,
        showNavbar: true,
        showIcon: true,
        meetingsync: 0,
        windowWidth: 0,
        windowHeight: 0
      }
    },
    destroyed(){
      window.removeEventListener("resize", this.onResize);
    }
  }
</script>

<style scoped>
  .footer {
    padding: 10px 15px;
  }

  .footer-content{
    height: 100%;
    width: 100%;
    display: flex;
    padding: 0;
    margin: 0;
    justify-content: space-between;
  }

  .left-side {
    width: 80%;
    display: inline-flex;
  }

  .footer-content *:not(i) {
    color: white;
  }

  .elapsed-time {
    align-self: center;
    font-size: 1.5rem;
    min-width: 200px;
  }

  .elapsed-time > span > i {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .elapsed-time > span > span {
    font-size: 1rem;
    opacity: .5;
  }

  .back-button {
    align-self: center;
  }

  .footer-icon {
    align-self: center;
    font-size: 1.5rem;
    margin-right: .5em;
  }

  .meeting-title {
    display: inline-flex;
    align-items: center;
  }

  .meeting-title > h2{
    margin: 0 .5rem 0 0;
  }

  .meeting-title > p {
    margin: 0 .5rem 0 0;
    opacity: .5;
  }

  .wifi-icon {
    margin-top: 13px;
    padding-top: 17px;
    color: black;
  }

  .font-rem {
    font-size: 0.75rem;
  }

  .container-base {
    padding: 0px;
  }

  .wrapper {
    padding-bottom: 0px;
  }

  .see-through-title {
    z-index: 5;
    position: relative;
    padding: 3rem 4rem 3rem 4rem;
  }

  .breadcrumbs {
    margin-top: -2rem;
    padding-right: 2rem;
  }

  .row-align {
    margin-left: 0;
  }

  .dropdown-user a:hover{
    color: #1bb5eb !important;
  }


  @media screen and (max-width: 1000px) {
    .footer-content {
      height: 35px;
    }

    .meeting-title {
      display: block;
      margin-right: 1.5rem;
    }

    .meeting-title > h2{
      font-size: 1.3rem;
      padding: 0;
      margin: 0;
    }

    .meeting-title > p {
      font-size: .75rem;
      padding: 0;
      margin: 0;
    }

  .left-side {
      width: 75%;
    }
  }

  @media screen and (max-width: 750px) {
    .meeting-title {
      display: none;
    }

    .elapsed-time {
      display: none;
    }

    .left-side {
      justify-content: center;
    }

    .left-side {
      width: 100%;
    }
  }

  .user-avatar{
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;

    object-fit: cover;
  }

  .circle-image{
    border-radius: 50% !important;
  }

  @media (min-width: 576px) {
    span.achiev-logo{
      display: inline-block;
    }
  }


  @media (max-width: 576px) {
    span.achiev-logo{
      display: none;
    }
  }

  @media screen and (max-width: 550px) {
    .see-through-title {
      padding: 3rem 4rem 3rem 1rem;
    }
  }
</style>

<style lang="scss">
  @import "../assets/scss/default-dark";
</style>



// WEBPACK FOOTER //
// src/components/Frame.vue